import { getMonth, getYear } from '@e3dc-react/shell/Libs/date'
import { FavoriteConfiguratorDto, PowerMeter, Component, Product } from '../dto/save-configurator.dto'
import { ShopSystemConfiguration } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'
import { ProductGeneralType } from '../../types'

const SYSTEM_CONFIGURATION_MINMUM_QUANTITY = 1

const systemConfigurationFromDtoToModelTransformer = (dto: FavoriteConfiguratorDto, month?: number, year?: number): ShopSystemConfiguration => {
  return {
    type: ProductGeneralType.SYSTEM_CONFIGURATOR,
    label: dto.name || '',
    quantity: SYSTEM_CONFIGURATION_MINMUM_QUANTITY,
    desiredShippingDate: {
      day: null,
      month: month ?? getMonth(new Date()),
      year: year ?? getYear(new Date()),
    },
    configuration: {
      configuratorId: dto.configuration.configuratorId || '',
      components: (dto.configuration?.components || []).map((component: Component) => ({
        id: component.id,
        products: (component.products || []).map((product: Product) => ({
          id: product.id,
          qty: product.qty,
        })),
      })),
      powerMeters: (dto.configuration?.powerMeters || []).map((powerMeter: PowerMeter) => ({
        id: powerMeter.id,
        powerMeterId: powerMeter.powerMeterId,
        powerConverterId: powerMeter.powerConverterId,
      })),
      retrofitBattery: dto.configuration.retrofitBattery || null,
      smartMeter: dto.configuration.smartMeter || null,
    },
  }
}

export default systemConfigurationFromDtoToModelTransformer
